import { Button } from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";
import styled from "styled-components";

type TinyMCEEditorProps = {
  onContentConfirm?: Function;
  onCancel?: Function;
  initialValue?: string;
};

const TinyMCEEditor = ({
  onContentConfirm,
  onCancel,
  initialValue,
}: TinyMCEEditorProps) => {
  const editorRef = useRef<any>(null);

  return (
    <div>
      <Editor
        apiKey="qpvp98mo5biolpjz1dz7ium280jrrl9u0xuibmdt5sz6fcqd"
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={initialValue}
        init={{
          height: 500,
          menubar: false,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "code",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic forecolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
      <DivButtons>
        <Button
          variant={"outlined"}
          onClick={() =>
            onContentConfirm
              ? onContentConfirm(editorRef.current.getContent())
              : null
          }
        >
          OK
        </Button>
        <ButtonCancel
          variant={"outlined"}
          onClick={() => (onCancel ? onCancel() : null)}
        >
          Cancel
        </ButtonCancel>
      </DivButtons>
    </div>
  );
};

const ButtonCancel = styled(Button)`
  &&& {
    margin-left: 1rem;
  }
`;

const DivButtons = styled.div`
  margin-top: 1rem;
`;

export default TinyMCEEditor;
